import React, { useState, useEffect } from "react";
import axiosInstance from "../../store/services/AxiosService";

const DevDashboard = () => {
	const [activeTab, setActiveTab] = useState("links"); // 'links' | 'create'
	const [schools, setSchools] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [degreeFilter, setDegreeFilter] = useState("ALL");
	const [copiedId, setCopiedId] = useState(null);

	const [formData, setFormData] = useState({
		api_url: "",
		api_name: "",
		degree: ""
	});
	const [submitting, setSubmitting] = useState(false);

	const fetchSchools = () => {
		setLoading(true);
		axiosInstance
			.get("/schools")
			.then((res) => {
				const data = Array.isArray(res.data) ? res.data : Object.values(res.data || {});
				setSchools(data);
				setLoading(false);
			})
			.catch((err) => {
				console.error("Gagal mengambil data sekolah:", err);
				setLoading(false);
			});
	};

	useEffect(() => {
		fetchSchools();
	}, []);

	const handleInputChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitting(true);
		axiosInstance
			.post("/schools/create", formData)
			.then((response) => {
				alert("Sekolah berhasil ditambahkan!");
				setFormData({
					api_url: "",
					api_name: "",
					degree: ""
				});
				setSubmitting(false);
				fetchSchools();
				setActiveTab("links");
			})
			.catch((error) => {
				setSubmitting(false);
				console.error("Error:", error);
				const msg =
					error.response?.data?.data?.error ||
					error.response?.data?.message ||
					error.message ||
					"Unknown error";
				alert("Gagal menambahkan sekolah: " + msg);
			});
	};

	const handleCopyUrl = (schoolId) => {
		const url = `${window.location.origin}/login-student?school_id=${schoolId}`;
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(url).then(() => {
				setCopiedId(schoolId);
				setTimeout(() => setCopiedId(null), 2200);
			}).catch(() => {
				copyFallback(url, schoolId);
			});
		} else {
			copyFallback(url, schoolId);
		}
	};

	const copyFallback = (text, schoolId) => {
		const textArea = document.createElement("textarea");
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();
		try {
			document.execCommand("copy");
			setCopiedId(schoolId);
			setTimeout(() => setCopiedId(null), 2200);
		} catch (err) {
			alert("Gagal menyalin link: " + text);
		}
		document.body.removeChild(textArea);
	};

	const filteredSchools = schools.filter((school) => {
		const q = searchTerm.toLowerCase();
		const matchesSearch =
			(school.api_name && school.api_name.toLowerCase().includes(q)) ||
			(school.api_url && school.api_url.toLowerCase().includes(q)) ||
			(school.degree && school.degree.toLowerCase().includes(q));
		const matchesDegree = degreeFilter === "ALL" || school.degree === degreeFilter;
		return matchesSearch && matchesDegree;
	});

	const renderDegreeBadge = (degree) => {
		const styles = {
			SD: { bg: "#ecfdf5", color: "#065f46", border: "#a7f3d0" },
			SMP: { bg: "#eff6ff", color: "#1e40af", border: "#bfdbfe" },
			SMA: { bg: "#fef3c7", color: "#92400e", border: "#fde68a" },
			SMK: { bg: "#fdf2f8", color: "#9d174d", border: "#fbcfe8" },
		};
		const s = styles[degree] || { bg: "#f1f5f9", color: "#475569", border: "#e2e8f0" };

		return (
			<span
				style={{
					backgroundColor: s.bg,
					color: s.color,
					border: `1px solid ${s.border}`,
					padding: "4px 10px",
					borderRadius: "6px",
					fontSize: "0.78rem",
					fontWeight: "700",
					display: "inline-block",
					letterSpacing: "0.03em"
				}}
			>
				{degree || "-"}
			</span>
		);
	};

	return (
		<div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", padding: "36px 20px", fontFamily: "inherit" }}>
			<div style={{ maxWidth: "1220px", margin: "0 auto" }}>
				
				{/* Top Bar: Clean Header & Navigation */}
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						justifyContent: "space-between",
						alignItems: "center",
						marginBottom: "28px",
						gap: "16px"
					}}
				>
					<div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
						<div
							style={{
								width: "48px",
								height: "48px",
								borderRadius: "12px",
								background: "linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								color: "#ffffff",
								fontSize: "24px",
								boxShadow: "0 4px 12px rgba(124, 58, 237, 0.25)"
							}}
						>
							<i className="mdi mdi-view-dashboard-outline"></i>
						</div>
						<div>
							<h2 style={{ fontSize: "1.45rem", fontWeight: "700", color: "#0f172a", margin: 0, lineHeight: 1.2 }}>
								Developer Dashboard
							</h2>
							<p style={{ fontSize: "0.875rem", color: "#64748b", margin: "3px 0 0 0" }}>
								Kelola integrasi sekolah dan akses cepat login siswa
							</p>
						</div>
					</div>

					<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
						<button
							type="button"
							onClick={() => (window.location.href = "/")}
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: "6px",
								backgroundColor: "#ffffff",
								color: "#475569",
								border: "1px solid #cbd5e1",
								borderRadius: "8px",
								padding: "8px 16px",
								fontSize: "0.875rem",
								fontWeight: "500",
								cursor: "pointer",
								transition: "all 0.2s"
							}}
							onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#f1f5f9"; e.currentTarget.style.color = "#0f172a"; }}
							onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#ffffff"; e.currentTarget.style.color = "#475569"; }}
						>
							<i className="mdi mdi-arrow-left" style={{ fontSize: "16px" }}></i>
							Kembali ke Beranda
						</button>
					</div>
				</div>

				{/* Segmented Pill Tabs */}
				<div style={{ display: "flex", marginBottom: "20px" }}>
					<div
						style={{
							display: "inline-flex",
							backgroundColor: "#e2e8f0",
							padding: "4px",
							borderRadius: "10px",
							gap: "4px"
						}}
					>
						<button
							type="button"
							onClick={() => setActiveTab("links")}
							style={{
								padding: "8px 20px",
								fontSize: "0.875rem",
								fontWeight: activeTab === "links" ? "600" : "500",
								color: activeTab === "links" ? "#0f172a" : "#64748b",
								backgroundColor: activeTab === "links" ? "#ffffff" : "transparent",
								border: "none",
								borderRadius: "8px",
								cursor: "pointer",
								boxShadow: activeTab === "links" ? "0 2px 4px rgba(0,0,0,0.06)" : "none",
								transition: "all 0.15s ease",
								display: "inline-flex",
								alignItems: "center",
								gap: "8px"
							}}
						>
							<i className="mdi mdi-link-variant" style={{ fontSize: "16px", color: activeTab === "links" ? "#7c3aed" : "#94a3b8" }}></i>
							Daftar URL Login Siswa
							<span
								style={{
									backgroundColor: activeTab === "links" ? "#f1f5f9" : "#cbd5e1",
									color: activeTab === "links" ? "#7c3aed" : "#475569",
									padding: "2px 8px",
									borderRadius: "12px",
									fontSize: "0.75rem",
									fontWeight: "700"
								}}
							>
								{schools.length}
							</span>
						</button>

						<button
							type="button"
							onClick={() => setActiveTab("create")}
							style={{
								padding: "8px 20px",
								fontSize: "0.875rem",
								fontWeight: activeTab === "create" ? "600" : "500",
								color: activeTab === "create" ? "#0f172a" : "#64748b",
								backgroundColor: activeTab === "create" ? "#ffffff" : "transparent",
								border: "none",
								borderRadius: "8px",
								cursor: "pointer",
								boxShadow: activeTab === "create" ? "0 2px 4px rgba(0,0,0,0.06)" : "none",
								transition: "all 0.15s ease",
								display: "inline-flex",
								alignItems: "center",
								gap: "6px"
							}}
						>
							<i className="mdi mdi-plus-circle-outline" style={{ fontSize: "16px", color: activeTab === "create" ? "#7c3aed" : "#94a3b8" }}></i>
							Tambah Sekolah Baru
						</button>
					</div>
				</div>

				{/* TAB 1: LIST URL LOGIN SISWA */}
				{activeTab === "links" && (
					<div
						style={{
							backgroundColor: "#ffffff",
							borderRadius: "14px",
							border: "1px solid #e2e8f0",
							boxShadow: "0 2px 8px -2px rgba(15, 23, 42, 0.05)",
							overflow: "hidden"
						}}
					>
						{/* Table Filter & Action Bar */}
						<div
							style={{
								padding: "20px 24px",
								borderBottom: "1px solid #f1f5f9",
								display: "flex",
								flexWrap: "wrap",
								justifyContent: "space-between",
								alignItems: "center",
								gap: "16px"
							}}
						>
							<div>
								<h3 style={{ fontSize: "1.05rem", fontWeight: "700", color: "#1e293b", margin: 0 }}>
									URL Login Khusus Siswa per Sekolah
								</h3>
								<p style={{ fontSize: "0.825rem", color: "#64748b", margin: "3px 0 0 0" }}>
									Bagikan link berikut ke grup siswa/guru agar siswa langsung login tanpa memilih jenjang & sekolah.
								</p>
							</div>

							<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
								{/* Search Bar */}
								<div style={{ position: "relative", minWidth: "240px" }}>
									<i
										className="mdi mdi-magnify"
										style={{
											position: "absolute",
											left: "11px",
											top: "50%",
											transform: "translateY(-50%)",
											color: "#94a3b8",
											fontSize: "18px"
										}}
									></i>
									<input
										type="text"
										placeholder="Cari sekolah atau jenjang..."
										value={searchTerm}
										onChange={(e) => setSearchTerm(e.target.value)}
										style={{
											width: "100%",
											padding: "8px 12px 8px 36px",
											fontSize: "0.85rem",
											border: "1px solid #cbd5e1",
											borderRadius: "8px",
											outline: "none",
											backgroundColor: "#f8fafc",
											color: "#1e293b",
											transition: "border 0.2s"
										}}
										onFocus={(e) => { e.target.style.borderColor = "#7c3aed"; e.target.style.backgroundColor = "#fff"; }}
										onBlur={(e) => { e.target.style.borderColor = "#cbd5e1"; e.target.style.backgroundColor = "#f8fafc"; }}
									/>
								</div>

								{/* Degree Filter */}
								<select
									value={degreeFilter}
									onChange={(e) => setDegreeFilter(e.target.value)}
									style={{
										padding: "8px 12px",
										fontSize: "0.85rem",
										border: "1px solid #cbd5e1",
										borderRadius: "8px",
										outline: "none",
										backgroundColor: "#f8fafc",
										color: "#334155",
										cursor: "pointer"
									}}
								>
									<option value="ALL">Semua Jenjang</option>
									<option value="SD">Jenjang SD</option>
									<option value="SMP">Jenjang SMP</option>
									<option value="SMA">Jenjang SMA</option>
									<option value="SMK">Jenjang SMK</option>
								</select>

								{/* Refresh Button */}
								<button
									type="button"
									onClick={fetchSchools}
									disabled={loading}
									style={{
										padding: "8px 14px",
										fontSize: "0.85rem",
										color: "#475569",
										backgroundColor: "#f1f5f9",
										border: "1px solid #cbd5e1",
										borderRadius: "8px",
										cursor: "pointer",
										display: "inline-flex",
										alignItems: "center",
										gap: "6px",
										fontWeight: "500"
									}}
									title="Refresh data sekolah"
								>
									<i className={`mdi mdi-refresh ${loading ? "mdi-spin" : ""}`}></i>
									Refresh
								</button>
							</div>
						</div>

						{/* Table Content */}
						{loading ? (
							<div style={{ textAlign: "center", padding: "60px 20px" }}>
								<i className="mdi mdi-loading mdi-spin" style={{ fontSize: "36px", color: "#7c3aed" }}></i>
								<p style={{ color: "#64748b", marginTop: "12px", fontSize: "0.9rem" }}>Memuat daftar sekolah...</p>
							</div>
						) : filteredSchools.length === 0 ? (
							<div style={{ textAlign: "center", padding: "60px 20px", color: "#94a3b8" }}>
								<i className="mdi mdi-school-outline" style={{ fontSize: "48px", display: "block", marginBottom: "8px", color: "#cbd5e1" }}></i>
								<p style={{ fontSize: "0.95rem", margin: 0, fontWeight: "500", color: "#64748b" }}>
									{searchTerm || degreeFilter !== "ALL" ? "Tidak ada sekolah yang cocok dengan filter." : "Belum ada data sekolah yang terdaftar."}
								</p>
							</div>
						) : (
							<div style={{ overflowX: "auto" }}>
								<table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
									<thead>
										<tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
											<th style={{ padding: "12px 16px", fontSize: "0.75rem", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", width: "50px", textAlign: "center" }}>
												No
											</th>
											<th style={{ padding: "12px 20px", fontSize: "0.75rem", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", width: "240px" }}>
												Nama Sekolah
											</th>
											<th style={{ padding: "12px 16px", fontSize: "0.75rem", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", width: "95px", textAlign: "center" }}>
												Jenjang
											</th>
											<th style={{ padding: "12px 20px", fontSize: "0.75rem", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>
												URL Login Khusus Siswa
											</th>
											<th style={{ padding: "12px 20px", fontSize: "0.75rem", fontWeight: "600", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", width: "180px", textAlign: "center" }}>
												Aksi
											</th>
										</tr>
									</thead>
									<tbody>
										{filteredSchools.map((school, index) => {
											const studentLoginUrl = `${window.location.origin}/login-student?school_id=${school.id}`;
											const isCopied = copiedId === school.id;

											return (
												<tr
													key={school.id || index}
													style={{
														borderBottom: "1px solid #f1f5f9",
														transition: "background-color 0.15s ease"
													}}
													onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#fafafa"; }}
													onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
												>
													{/* No */}
													<td style={{ padding: "16px", textAlign: "center", color: "#94a3b8", fontSize: "0.85rem", fontWeight: "500" }}>
														{index + 1}
													</td>

													{/* Nama Sekolah & Server */}
													<td style={{ padding: "16px 20px" }}>
														<div style={{ fontWeight: "600", color: "#1e293b", fontSize: "0.92rem", marginBottom: "2px" }}>
															{school.api_name || "Tanpa Nama"}
														</div>
														<div style={{ color: "#64748b", fontSize: "0.78rem" }}>
															<span style={{ color: "#94a3b8" }}>Server:</span> {school.api_url}
														</div>
													</td>

													{/* Jenjang */}
													<td style={{ padding: "16px", textAlign: "center" }}>
														{renderDegreeBadge(school.degree)}
													</td>

													{/* URL Login Khusus */}
													<td style={{ padding: "16px 20px" }}>
														<div
															style={{
																display: "inline-flex",
																alignItems: "center",
																backgroundColor: "#f8fafc",
																border: "1px solid #e2e8f0",
																borderRadius: "8px",
																padding: "6px 12px",
																maxWidth: "100%",
																width: "100%"
															}}
														>
															<i className="mdi mdi-link-variant" style={{ color: "#7c3aed", marginRight: "8px", fontSize: "16px" }}></i>
															<span
																style={{
																	fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
																	fontSize: "0.825rem",
																	color: "#334155",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	whiteSpace: "nowrap"
																}}
															>
																{studentLoginUrl}
															</span>
														</div>
													</td>

													{/* Aksi */}
													<td style={{ padding: "16px 20px", textAlign: "center" }}>
														<div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
															{/* Salin URL Button */}
															<button
																type="button"
																onClick={() => handleCopyUrl(school.id)}
																style={{
																	display: "inline-flex",
																	alignItems: "center",
																	gap: "5px",
																	backgroundColor: isCopied ? "#10b981" : "#7c3aed",
																	color: "#ffffff",
																	border: "none",
																	borderRadius: "7px",
																	padding: "7px 12px",
																	fontSize: "0.8rem",
																	fontWeight: "600",
																	cursor: "pointer",
																	boxShadow: isCopied ? "0 2px 6px rgba(16, 185, 129, 0.3)" : "0 2px 6px rgba(124, 58, 237, 0.25)",
																	transition: "all 0.2s ease"
																}}
																title="Salin tautan ini untuk dibagikan ke siswa/guru"
															>
																<i className={`mdi ${isCopied ? "mdi-check-bold" : "mdi-content-copy"}`} style={{ fontSize: "14px" }}></i>
																{isCopied ? "Tersalin!" : "Salin URL"}
															</button>

															{/* Buka Link Button */}
															<a
																href={studentLoginUrl}
																target="_blank"
																rel="noopener noreferrer"
																style={{
																	display: "inline-flex",
																	alignItems: "center",
																	justifyContent: "center",
																	width: "32px",
																	height: "32px",
																	backgroundColor: "#ffffff",
																	color: "#64748b",
																	border: "1px solid #cbd5e1",
																	borderRadius: "7px",
																	textDecoration: "none",
																	cursor: "pointer",
																	transition: "all 0.15s ease"
																}}
																title="Buka link di tab baru"
																onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#f1f5f9"; e.currentTarget.style.color = "#0f172a"; }}
																onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#ffffff"; e.currentTarget.style.color = "#64748b"; }}
															>
																<i className="mdi mdi-open-in-new" style={{ fontSize: "15px" }}></i>
															</a>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
				)}

				{/* TAB 2: TAMBAH SEKOLAH BARU */}
				{activeTab === "create" && (
					<div style={{ maxWidth: "560px", margin: "20px auto 0 auto" }}>
						<div
							style={{
								backgroundColor: "#ffffff",
								borderRadius: "14px",
								border: "1px solid #e2e8f0",
								boxShadow: "0 4px 12px -2px rgba(15, 23, 42, 0.05)",
								padding: "36px 32px"
							}}
						>
							<div style={{ textAlign: "center", marginBottom: "26px" }}>
								<div
									style={{
										width: "48px",
										height: "48px",
										borderRadius: "50%",
										backgroundColor: "#f5f3ff",
										color: "#7c3aed",
										display: "inline-flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: "24px",
										marginBottom: "12px"
									}}
								>
									<i className="mdi mdi-school-outline"></i>
								</div>
								<h3 style={{ fontSize: "1.25rem", fontWeight: "700", color: "#0f172a", margin: 0 }}>
									Tambah Konfigurasi Sekolah
								</h3>
								<p style={{ fontSize: "0.85rem", color: "#64748b", marginTop: "4px" }}>
									Daftarkan unit sekolah baru untuk terintegrasi dengan ujian online
								</p>
							</div>

							<form onSubmit={handleSubmit}>
								<div style={{ marginBottom: "18px" }}>
									<label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: "#334155", marginBottom: "6px" }}>
										URL Server MHS Sekolah
									</label>
									<input
										type="url"
										name="api_url"
										value={formData.api_url}
										onChange={handleInputChange}
										placeholder="https://dev.myhomeschool.co.id"
										required
										style={{
											width: "100%",
											padding: "10px 14px",
											fontSize: "0.9rem",
											border: "1px solid #cbd5e1",
											borderRadius: "8px",
											outline: "none",
											backgroundColor: "#f8fafc",
											boxSizing: "border-box"
										}}
										onFocus={(e) => { e.target.style.borderColor = "#7c3aed"; e.target.style.backgroundColor = "#fff"; }}
										onBlur={(e) => { e.target.style.borderColor = "#cbd5e1"; e.target.style.backgroundColor = "#f8fafc"; }}
									/>
									<small style={{ color: "#94a3b8", fontSize: "0.78rem", marginTop: "4px", display: "block" }}>
										Masukkan URL domain API server sekolah tujuan
									</small>
								</div>

								<div style={{ marginBottom: "18px" }}>
									<label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: "#334155", marginBottom: "6px" }}>
										Nama Sekolah
									</label>
									<input
										type="text"
										name="api_name"
										value={formData.api_name}
										onChange={handleInputChange}
										placeholder="Contoh: Sekolah Apri Unity"
										required
										style={{
											width: "100%",
											padding: "10px 14px",
											fontSize: "0.9rem",
											border: "1px solid #cbd5e1",
											borderRadius: "8px",
											outline: "none",
											backgroundColor: "#f8fafc",
											boxSizing: "border-box"
										}}
										onFocus={(e) => { e.target.style.borderColor = "#7c3aed"; e.target.style.backgroundColor = "#fff"; }}
										onBlur={(e) => { e.target.style.borderColor = "#cbd5e1"; e.target.style.backgroundColor = "#f8fafc"; }}
									/>
								</div>

								<div style={{ marginBottom: "26px" }}>
									<label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: "#334155", marginBottom: "6px" }}>
										Jenjang Pendidikan
									</label>
									<select
										name="degree"
										value={formData.degree}
										onChange={handleInputChange}
										required
										style={{
											width: "100%",
											padding: "10px 14px",
											fontSize: "0.9rem",
											border: "1px solid #cbd5e1",
											borderRadius: "8px",
											outline: "none",
											backgroundColor: "#f8fafc",
											color: "#334155",
											cursor: "pointer",
											boxSizing: "border-box"
										}}
									>
										<option value="">-- Pilih Jenjang --</option>
										<option value="SD">SD</option>
										<option value="SMP">SMP</option>
										<option value="SMA">SMA</option>
										<option value="SMK">SMK</option>
									</select>
								</div>

								<div style={{ display: "flex", gap: "12px" }}>
									<button
										type="submit"
										disabled={submitting}
										style={{
											flex: 1,
											backgroundColor: "#7c3aed",
											color: "#ffffff",
											border: "none",
											borderRadius: "8px",
											padding: "12px 20px",
											fontSize: "0.9rem",
											fontWeight: "600",
											cursor: "pointer",
											boxShadow: "0 2px 6px rgba(124, 58, 237, 0.3)",
											transition: "background-color 0.2s"
										}}
									>
										{submitting ? "Menyimpan..." : "Simpan Sekolah"}
									</button>
									<button
										type="button"
										onClick={() => setActiveTab("links")}
										style={{
											flex: 1,
											backgroundColor: "#ffffff",
											color: "#64748b",
											border: "1px solid #cbd5e1",
											borderRadius: "8px",
											padding: "12px 20px",
											fontSize: "0.9rem",
											fontWeight: "600",
											cursor: "pointer"
										}}
									>
										Batal
									</button>
								</div>
							</form>
						</div>
					</div>
				)}

			</div>
		</div>
	);
};

export default DevDashboard;
